import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import React from "react";
import {Box} from "@mui/material";

const StackIconButton = ({iconProps, buttonProps, icon =      ['fas', 'wifi'], iconClassname = null}) => {
    return <Box display="flex" alignItems="center" className="fa-stack" {...buttonProps}>
        <FontAwesomeIcon {...iconProps} style={{color: 'tomato', width: '1.7em', height: '1.8em'}} className={'fa-stack-2x'} icon={["fas", "ban"]} />
        <FontAwesomeIcon {...iconProps} style={iconClassname === null ? {color: '#FFF'} : {}} className={'fa-stack-1x' + (iconClassname ? ' ' + iconClassname : '')}  icon={icon}  />
    </Box>
}

export default StackIconButton;